<template>
    <div class="opModal">
        <div class="modalBody p-4">
            <div class="text-center" v-html="text"></div>
            <div class="text-center mt-2">
                <template v-if="timer <= 0">
                    <input class="form-control" v-model="checkText" />
                </template>
                <button type="button" class="btn roundedButton btn-primary mt-3" @click="ok" :disabled="timer > 0 || checkText.toLowerCase() != 'confermo'">
                    <template v-if="timer > 0">
                        Attendi {{timer}}
                    </template> CONFERMO
                </button>
            </div>
            <div class="text-center mt-5">
                <button type="button" class="btn roundedButton btn-danger" @click="$emit('close')">
                    ANNULLA
                </button>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import * as OM from '@/model';
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Options({})
export default class confirmAccountDeletionModal extends Vue {

    @Prop() text: string;
    @Prop() okCb: () => void;

    timer = 5;
    interval = null;
    checkText: string = "";

    created(){
        this.interval = setInterval(() => {
            this.timer--;
            if(this.timer <= 0){
                clearInterval(this.interval);
            }
        }, 1000)
    }

    destroyed(){
        clearInterval(this.interval);
    }

    ok(){
        this.$emit('close');
        this.okCb();
    }

}

</script>

<style scoped>

.opModal {
    height: auto;
}

</style>
